export default "__VITE_ASSET__DoZHBKQU__"